export default __webpack_public_path__ + "app/assets/marker-shadow-a0c6cc14.png";